/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState, useEffect } from 'react';
import * as Elements from '../elements';
import * as API from '../../http/api';
import { useHistory } from 'react-router-dom';
import { openlightbox } from '../../util/Functions';
import { CardCancel, Factor, CardReplace } from '../modals';
import { useStyles } from "../../util/ComponentStyles";
import { Paper, Typography } from "@mui/material";
import { CreditCard } from "@mui/icons-material";

const CardList = (props) => {
    const [blocked, setBlocked] = useState(false);
    const [blockCancel, setBlockCancel] = useState(true);
    const [headers, setHeaders] = useState([]);
    const [data, setData] = useState([]);
    const [keys, setKeys] = useState([]);
    const [item, setItem] = useState({});
    const history = useHistory();
    const clasess = useStyles();
    
    useEffect(() => {
        setBlockCancel(true);
        setBlocked(false);
        setItem({});
        setHeaders(JSON.parse(JSON.stringify(props.item.content.headers)));
        setData(JSON.parse(JSON.stringify(props.item.content.data)));
        setKeys(JSON.parse(JSON.stringify(props.item.content.keys)));
    }, [props.item.content.data]);

    const changeReload = async () => {
        props.changeLoader(true);
        let request = await API.service('tarjetas', props.item.customerUuid, props.pos, props.changeAlert, props.changeLoader, history);
        if(request.status == 200 && request.data.data.response == 'OK'){
            //let w = [props.widgets[0]];
            //let moreWidgets = w.concat(request.data.data.widget)
            props.changeWidgets(JSON.parse(JSON.stringify(request.data.data.widget)));
        }
        props.changeLoader(false);
    }

    const blockUnBlock = async (action) => {
        if (!item.hasOwnProperty('uuid') || (item['status'] !== 'Bloqueada' && item['status'] !== 'Activa')) {
            return;
        }
    
        const b = !blocked;
    
        let data = {
            customerUuid: props.item.customerUuid,//TWO_FACTOR_AUTH
            cardUuid: item['uuid'],
            action: b ? 'block' : 'unblock',
            reasonCode: 10,
        };
        props.changeLoader(true);
    
        let request = await API.service(action, data, props.pos, props.changeAlert, props.changeLoader, history);
        if(request.status == 200 && request.data.data.response == 'OK' && request.data.data.content){
            if(request.data.data.content.type == '2FA' || request.data.data.content.type == '1FA'){
                let factors = localStorage.factors ? JSON.parse(localStorage.factors) : {};
                factors[props.item.customerUuid] = request.data.data.content.uuid_factor;
                localStorage.factors = JSON.stringify(factors);
            }
            const as = <Factor
                intent={action}
                contentModal={request.data.data.content}
                pos={props.pos}
                changeAlert={props.changeAlert}
                changeLoader={props.changeLoader}
                history={history}
                key="factor"
                continue={() => next(action)}
            />
            openlightbox(as);
        }
        if(request.status == 200 && request.data.data.response == 'OK' && !request.data.data.content) {
            setBlocked(b);
            item['status'] = b ? 'Bloqueada' : 'Activa';
            changeStatus(item);
            props.changeAlert(true, 'success', 'Datos actualizados con éxito');
        }
        props.changeLoader(false);
    }
    
    const next = (action) => {
        action === "cardUnBlock" ? unBlock() : block();
    };
    const block = () => {
        return blockUnBlock("cardBlock");
    };
    const unBlock = () => {
        return blockUnBlock("cardUnBlock");
    };

    const changeStatus = (item) => {
        let d = data;
        for(let i = 0; i<d.length; i++){
            if(item.uuid == d[i]['uuid']){
                d[i]['status'] = item.status;
                if(item.hasOwnProperty('reasonCancel')){
                    d[i]['reasonCancel'] = item['reasonCancel'];
                }
            }
        }
        props.item.content.data = d;
        setData(JSON.parse(JSON.stringify(d)));
    }

    const cancel = async () => {
        if (!item.hasOwnProperty('uuid')) {
            return;
        }
    
        let data = {
            customerUuid: props.item.customerUuid,
            cardUuid: item['uuid'],
            spaceUuid: item['spaceUuid'],
            partner: item['partner'],
            pan: item['pan']
        };
        props.changeLoader(true);
    
        let request = await API.service('openModalCardCancel', data, props.pos, props.changeAlert, props.changeLoader, history);
        if (request.status == 200 && request.data.data.response == "OK" && request.data.data.widget.length == 0 && request.data.data.content) {
            if(request.data.data.content.type == '2FA' || request.data.data.content.type == '1FA'){
                let factors = localStorage.factors ? JSON.parse(localStorage.factors) : {};
                factors[props.item.customerUuid] = request.data.data.content.uuid_factor;
                localStorage.factors = JSON.stringify(factors);
            }
            const as = <Factor
                intent="openModalCardCancel"
                contentModal={request.data.data.content}
                pos={props.pos}
                changeAlert={props.changeAlert}
                changeLoader={props.changeLoader}
                history={history}
                key="factor"
            />
            openlightbox(as);
        }

        if (request.status == 200 && request.data.data.response == 'OK' && request.data.data.widget.length > 0) {
            let widg = request.data.data.widget;
            if (widg[0]?.type === 'cardCancel') {
                const as = <CardCancel 
                    content={widg[0].content ? widg[0].content : {}}
                    pos={props.pos}
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    key="cardCancel"
                    customerUuid={props.item.customerUuid}
                    changeStatus={changeStatus}
                    changeReload={changeReload}
                />
                openlightbox(as);
            }
        }
        props.changeLoader(false);
    }
    
    const replace = async () => {
        // console.log(item);
        if (!item.hasOwnProperty('uuid')) {
            return;
        }

        let dataReq = {
            customerUuid: props.item.customerUuid,
            type: item['type'],
            cardUuid: item['uuid'],
            spaceUuid: item['spaceUuid'],
            partner: item['partner'],
        };
        props.changeLoader(true);
    
        let request = await API.service('openModalCardReplace', dataReq, props.pos, props.changeAlert, props.changeLoader, history);
        if (request.status == 200 && request.data.data.response == "OK" && request.data.data.widget.length == 0 && request.data.data.content) {
            if(request.data.data.content.type == '2FA' || request.data.data.content.type == '1FA'){
                let factors = localStorage.factors ? JSON.parse(localStorage.factors) : {};
                factors[props.item.customerUuid] = request.data.data.content.uuid_factor;
                localStorage.factors = JSON.stringify(factors);
            }
            const as = <Factor
                intent="openModalCardReplace"
                contentModal={request.data.data.content}
                pos={props.pos}
                changeAlert={props.changeAlert}
                changeLoader={props.changeLoader}
                history={history}
                key="factor"
            />
            openlightbox(as);
        }
        if (request.status == 200 && request.data.data.response == 'OK' && request.data.data.widget.length > 0) {
            let widg = request.data.data.widget;
            if (widg[0]?.type === 'cardReplace') {
                const as = <CardReplace 
                    content={widg[0].content ? widg[0].content : {}}
                    pos={props.pos}
                    customerUuid={props.item.customerUuid}
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    changeReload={changeReload}
                    key="cardReplace" 
                    partner={item['partner']}
                />
                openlightbox(as);
            }
        }
    
        props.changeLoader(false);
    }

    const hasAction = (action) => {
        return props.config?.actions?.indexOf(action) > -1;
    }

    const changeRadio = (item) => {
        if(item.hasOwnProperty('uuid')){
            setItem(JSON.parse(JSON.stringify(item)));
            if(item.status == 'disabled' || item.status == 'Inactiva' || item.status == 'cancel' || item.status == 'Cancelada' || item.status == 'Cancelado'){
                setBlockCancel(true);
            } else {
                setBlockCancel(false);
            }
            if(item.status == 'Bloqueada'){
                setBlocked(true);
            } else {
                setBlocked(false);
            }
        } else {
            setBlocked(false);
            setBlockCancel(true);
            setItem({});
        }
    }

    return (
        <Paper className={clasess.limitsDetail}>
            <Typography
                component="div"
                children={
                    <div className={clasess.titleTable} style={{padding: "10px"}}>
                        <h2 className={clasess.titleH2}>
                            <CreditCard className={clasess.iconTitle2} fontSize={"large"}/>
                            Tarjetas
                        </h2>

                        <div className="col-5 inputIconRight" style={{marginRight: "15px"}}>
                            <div className="row pos-right">
                            { hasAction('block') &&
                                <div className={`switcher mini padding-right desktop fx-switcher-top ${blocked ? 'active' : ''}`} onClick={blocked ? unBlock : block}>
                                    <div className="switcherSlider"><div className="switcherSliderCircle" /></div>
                                    <label className='col-3 fix-lb-spaces-bloq'>Bloquear</label>
                                </div>
                            }
                            { hasAction('cancel') &&
                                <div className={blockCancel ? 'bigButton padding-right desktop disable' : 'bigButton padding-right desktop'}>
                                    <button onClick={cancel} disabled={blockCancel}>Cancelar</button>
                                </div>
                            }
                            { hasAction('replace') &&
                                <div className={blockCancel ? 'bigButton padding-left desktop disable' : 'bigButton padding-left desktop'}>
                                    <button onClick={replace} disabled={blockCancel}>Reemplazar</button>
                                </div>
                            }
                            </div>
                        </div>
                    </div>
                }
            />

            <p style={{marginTop: -20, marginLeft: 16}}>Selecciona una tarjeta para su edición:</p>

            <Elements.DataTable
                headers={headers}
                data={data}
                keys={keys}
                type={'radio'}
                options={true}
                changeRadio={changeRadio}
                hasAction={hasAction}
            />
        </Paper>
    )
}

export default CardList;